import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AlertService } from '../alert';
import { InventoryService } from '../services/inventory.service';
import { AuthenticationService, Token } from '../services';

@Component({
  selector: 'app-inventory',
  providers: [InventoryService],
  templateUrl: './inventory.component.html',  
  styleUrls: ['./inventory.component.css']  
})
export class InventoryComponent implements OnInit {

  loading = false;
  articles: any[] = [];
  articlesFiltered: any[] = [];

  constructor(
    private router: Router,
    private inventoryService: InventoryService,
    private alertService: AlertService,
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.getArticles();
  }

  doesMatch(element: any, filter) { 
    return ((element.name!=null && element.name.toLowerCase().indexOf(filter.toLowerCase())) >= 0 || 
            (element.description!=null && element.description.toLowerCase().indexOf(filter.toLowerCase()) >= 0 ||
            (element.articleRef!=null && element.articleRef.toLowerCase().indexOf(filter.toLowerCase()) >= 0)));
  } 

  doFilter(filterValue) {
    this.articlesFiltered = [];
    this.articles.forEach(article => {
      if (this.doesMatch(article, filterValue)) {
        this.articlesFiltered.push(article);
      }
    });
  }

  remove(articleRef: string) {
        this.loading = true;
        this.inventoryService.deleteArticle(articleRef)
            .subscribe(
            data => {
                this.loading = false;
                this.getArticles();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            });
    
  }

  addArticle() {
    this.router.navigate(['/article', 'new']);
  }

  select(event) {
      this.router.navigate(['/article', '' + event.articleRef]);
  }

  getArticles() {
        this.loading = true;
        this.inventoryService.getArticles()
            .subscribe(
            data => {
                this.articles = data;
                this.doFilter('');
                this.loading = false;
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/inventory/inventory.component.ts